import React, { useState } from 'react';
import {
  ISchedulePeriod,
  IDailyConfig,
  DAY_NAMES_ENG,
  WEEK_DAYS_ENG,
} from '../interfaces/schedule-period.interface';
import { DefaultButton } from 'shared/ui';
import { parseDateFromDatetime } from 'shared/lib';
import styles from './settings.module.scss';

interface IPeriodsListProps {
  periods: ISchedulePeriod[];
  onDelete: (period: ISchedulePeriod) => void;
}

const MODE_LABELS: Record<string, string> = {
  shift: 'Посменный',
  weekly: 'Недельный',
};

function formatPeriodRange(p: ISchedulePeriod): string {
  const start = parseDateFromDatetime(p.dateStart);
  if (p.dateEnd && p.dateEnd !== p.dateStart) {
    return `с ${start} до ${parseDateFromDatetime(p.dateEnd)}`;
  }
  return start;
}

function formatModeDetail(p: ISchedulePeriod): string {
  if (p.mode === 'daily') {
    const cfg = p.config as IDailyConfig;
    if (cfg.startedAt === '00:00' && cfg.finishedAt === '00:00') {
      return 'Выходной';
    }
    return `${cfg.startedAt} - ${cfg.finishedAt}`;
  }
  if (p.mode === 'shift' && 'daysRunning' in p.config) {
    return `${p.config.daysRunning}/${p.config.daysOver}`;
  }
  if (p.mode === 'weekly' && 'monday' in p.config) {
    const cfg =
      p.config as import('../interfaces/schedule-period.interface').IWeeklyConfig;
    const workingDays = WEEK_DAYS_ENG.filter((day) => !cfg[day].isDayOff).map(
      (day) => DAY_NAMES_ENG[day]
    );
    return workingDays.join(', ');
  }
  return '';
}

export const PeriodsList: React.FC<IPeriodsListProps> = ({
  periods,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  if (periods.length === 0) return null;

  return (
    <div className={styles.periods_list}>
      <div
        className={styles.periods_list__header}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.periods_list__arrow}>{isOpen ? '▲' : '▼'}</span>
        <span className={styles.periods_list__title}>Настроенные периоды</span>
      </div>

      {isOpen &&
        periods.map((p) => (
          <div key={p.id} className={styles.periods_list__item}>
            <div className={styles.periods_list__info}>
              <span className={styles.periods_list__date}>
                {formatPeriodRange(p)}
              </span>
              {p.mode !== 'daily' && (
                <span className={styles.periods_list__mode}>
                  {MODE_LABELS[p.mode]}
                </span>
              )}
              {formatModeDetail(p) && (
                <span className={styles.periods_list__detail}>
                  {formatModeDetail(p)}
                </span>
              )}
            </div>
            <DefaultButton
              buttonText="Удалить"
              color="red"
              className={styles.periods_list__delete}
              onClick={() => onDelete(p)}
            />
          </div>
        ))}
    </div>
  );
};
